"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Content = _interopRequireDefault(require("../common/Content"));

var _EventHeader = _interopRequireDefault(require("./EventHeader"));

var _EventAttendees = _interopRequireDefault(require("./EventAttendees"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _axios = _interopRequireDefault(require("axios"));

var _EventDateFormatter = _interopRequireDefault(require("./EventDateFormatter"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _FeaturedTopicsListAsSearchResults = _interopRequireDefault(require("./FeaturedTopicsListAsSearchResults"));

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _EventDetails = _interopRequireDefault(require("@insided/deprecated-preact-components/Event/EventDetails"));

var _EventSettings = require("@insided/deprecated-control/Event/event-settings/EventSettings");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'event';
exports.cssAnchorName = cssAnchorName;

var EventView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(EventView, _Component);

  var _super = _createSuper(EventView);

  function EventView(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventView);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isEventEngagementEnabled", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleAt", void 0);

    var _props$event = _objectSpread({}, props.event),
        isLoggedInUserAttendee = _props$event.isLoggedInUserAttendee,
        attendeeCount = _props$event.attendeeCount,
        attendees = _props$event.attendees,
        startAt = _props$event.startAt,
        endAt = _props$event.endAt,
        timezoneName = _props$event.timezoneName;

    var timeConfig = _this.props.timeConfig;
    _this.state = {
      isAttendee: isLoggedInUserAttendee,
      isLoading: false,
      showModalEditRsvp: false,
      showModalAttendConfirmation: false,
      rsvpStatus: isLoggedInUserAttendee,
      page: 1,
      isAttendeesLoading: false,
      attendeeCount: attendeeCount,
      attendees: attendees,
      isLoadingConfirm: false,
      isLoadingUpdate: false,
      isLoadingAttend: false
    };
    _this.isEventEngagementEnabled = ((0, _globals.default)('activeModules') || []).includes('eventEngagement');

    var _getTimeSettings = (0, _EventSettings.getTimeSettings)(timeConfig, timezoneName),
        hour12 = _getTimeSettings.hour12,
        showTimezone = _getTimeSettings.showTimezone,
        eventTimezone = _getTimeSettings.eventTimezone;

    _this.scheduleAt = _EventDateFormatter.default.formatDateForEventView(startAt, endAt, hour12, showTimezone, eventTimezone);
    _this.onAttend = _this.onAttend.bind((0, _assertThisInitialized2.default)(_this));
    _this.onEditRsvp = _this.onEditRsvp.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCloseModalAttendConfirmation = _this.onCloseModalAttendConfirmation.bind((0, _assertThisInitialized2.default)(_this));
    _this.onCloseModalEditRsvp = _this.onCloseModalEditRsvp.bind((0, _assertThisInitialized2.default)(_this));
    _this.loadNextPage = _this.loadNextPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.appleCalendarICSDownloader = _this.appleCalendarICSDownloader.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EventView, [{
    key: "onAttendanceChanged",
    value: function onAttendanceChanged(isAttending) {
      this.setState({
        rsvpStatus: isAttending
      });
    }
  }, {
    key: "onEditRsvp",
    value: function onEditRsvp() {
      this.setState({
        showModalEditRsvp: true
      });
    }
  }, {
    key: "onCloseModalEditRsvp",
    value: function onCloseModalEditRsvp() {
      this.setState({
        showModalEditRsvp: false
      });
    }
  }, {
    key: "onUpdateRsvp",
    value: function () {
      var _onUpdateRsvp = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(e) {
        var res;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();

                if (!this.state.rsvpStatus) {
                  _context.next = 4;
                  break;
                }

                this.setState({
                  showModalEditRsvp: false
                });
                return _context.abrupt("return");

              case 4:
                this.setState({
                  isLoadingUpdate: true
                });
                _context.prev = 5;
                _context.next = 8;
                return _axios.default.post('/event/cancelSignUp', {
                  eventId: this.props.event.id
                });

              case 8:
                res = _context.sent;
                this.setState({
                  isAttendee: false,
                  showModalEditRsvp: false,
                  isLoadingAttend: false,
                  attendees: res.data,
                  attendeeCount: this.state.attendeeCount - 1,
                  isAttendeesLoading: false,
                  isLoadingUpdate: false
                });
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                this.setState({
                  isAttendee: false,
                  isLoadingAttend: false,
                  isAttendeesLoading: false,
                  isLoadingUpdate: false
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 12]]);
      }));

      function onUpdateRsvp(_x) {
        return _onUpdateRsvp.apply(this, arguments);
      }

      return onUpdateRsvp;
    }()
  }, {
    key: "onCloseModalAttendConfirmation",
    value: function onCloseModalAttendConfirmation() {
      this.setState({
        showModalAttendConfirmation: false,
        isLoadingAttend: false,
        isLoadingConfirm: false
      });
    }
  }, {
    key: "onAttend",
    value: function () {
      var _onAttend = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var user, event, res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                user = (0, _insidedDataStorage.getInsidedData)('user');

                if (user.userid) {
                  _context2.next = 5;
                  break;
                }

                event = new window.CustomEvent('GuestUserAction');
                window.dispatchEvent(event);
                return _context2.abrupt("return");

              case 5:
                this.setState({
                  isLoadingAttend: true
                });
                _context2.prev = 6;
                _context2.next = 9;
                return _axios.default.post('/event/signUp', {
                  eventId: this.props.event.id
                });

              case 9:
                res = _context2.sent;
                this.setState({
                  isAttendee: true,
                  rsvpStatus: true,
                  attendees: res.data,
                  attendeeCount: this.state.attendeeCount + 1,
                  isAttendeesLoading: false,
                  showModalAttendConfirmation: true
                });
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](6);
                this.setState({
                  isAttendee: false,
                  isLoadingAttend: false,
                  isAttendeesLoading: false,
                  isLoadingConfirm: false,
                  showModalAttendConfirmation: false
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 13]]);
      }));

      function onAttend() {
        return _onAttend.apply(this, arguments);
      }

      return onAttend;
    }()
  }, {
    key: "loadNextPage",
    value: function () {
      var _loadNextPage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var res;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _context3.prev = 1;
                _context3.next = 4;
                return _axios.default.get("/events/".concat(this.props.event.id, "/attendees?page=").concat(this.state.page + 1));

              case 4:
                res = _context3.sent;
                this.setState(function (prev) {
                  return _objectSpread(_objectSpread({}, prev), {}, {
                    page: prev.page + 1,
                    attendees: prev.attendees.concat(res.data)
                  });
                });
                _context3.next = 10;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

              case 10:
                this.setState({
                  isLoading: false
                });

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 8]]);
      }));

      function loadNextPage() {
        return _loadNextPage.apply(this, arguments);
      }

      return loadNextPage;
    }()
  }, {
    key: "createGoogleCalendarLink",
    value: function createGoogleCalendarLink() {
      var _location$replace;

      if (typeof window === 'undefined') return '';
      var baseLink = 'https://www.google.com/calendar/event?action=TEMPLATE';
      var _this$props$event = this.props.event,
          title = _this$props$event.title,
          location = _this$props$event.location,
          startAt = _this$props$event.startAt,
          endAt = _this$props$event.endAt;
      var formattedTitle = encodeURIComponent(title);
      var formattedLocation = (_location$replace = location === null || location === void 0 ? void 0 : location.replace(' ', '+')) !== null && _location$replace !== void 0 ? _location$replace : '';

      var formattedStartAt = _EventDateFormatter.default.formatDateForGoogleCalenderLink(startAt);

      var formattedEndAt = _EventDateFormatter.default.formatDateForGoogleCalenderLink(endAt);

      var details = "Click here to join the event: ".concat(window.location.href);
      return "".concat(baseLink, "&text=").concat(formattedTitle, "&details=").concat(details, "&location=").concat(formattedLocation, "&dates=").concat(formattedStartAt, "/").concat(formattedEndAt);
    }
  }, {
    key: "createOutlookCalendarLink",
    value: function createOutlookCalendarLink() {
      var _location$replace2;

      if (typeof window === 'undefined') return '';
      var baseLink = 'https://outlook.live.com/calendar/0/action/compose?allday=false&';
      var _this$props$event2 = this.props.event,
          title = _this$props$event2.title,
          location = _this$props$event2.location,
          startAt = _this$props$event2.startAt,
          endAt = _this$props$event2.endAt;
      var formattedTitle = encodeURIComponent(title);
      var formattedLocation = (_location$replace2 = location === null || location === void 0 ? void 0 : location.replace(' ', '+')) !== null && _location$replace2 !== void 0 ? _location$replace2 : '';
      var formattedStartAt = new Date(startAt * 1000).toISOString();
      var formattedEndAt = new Date(endAt * 1000).toISOString();
      var details = "Click here to join the event: ".concat(window.location.href);
      return "".concat(baseLink, "&subject=").concat(formattedTitle, "&body=").concat(details, "&location=").concat(formattedLocation, "&startdt=").concat(formattedStartAt, "&enddt=").concat(formattedEndAt);
    }
  }, {
    key: "createOffice365CalendarLink",
    value: function createOffice365CalendarLink() {
      var _location$replace3;

      if (typeof window === 'undefined') return '';
      var baseLink = 'https://outlook.office.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=addevent';
      var _this$props$event3 = this.props.event,
          title = _this$props$event3.title,
          location = _this$props$event3.location,
          startAt = _this$props$event3.startAt,
          endAt = _this$props$event3.endAt;
      var formattedTitle = encodeURIComponent(title);
      var formattedLocation = (_location$replace3 = location === null || location === void 0 ? void 0 : location.replace(' ', '+')) !== null && _location$replace3 !== void 0 ? _location$replace3 : '';
      var formattedStartAt = new Date(startAt * 1000).toISOString();
      var formattedEndAt = new Date(endAt * 1000).toISOString();
      var details = "Click here to join the event: ".concat(window.location.href);
      return "".concat(baseLink, "&startdt=").concat(formattedStartAt, "&enddt=").concat(formattedEndAt, "&subject=").concat(formattedTitle, "&body=").concat(details, "&location=").concat(formattedLocation);
    }
  }, {
    key: "appleCalendarICSDownloader",
    value: function appleCalendarICSDownloader() {
      var _this$props$event4 = this.props.event,
          title = _this$props$event4.title,
          location = _this$props$event4.location,
          startAt = _this$props$event4.startAt,
          endAt = _this$props$event4.endAt;
      var details = "Click here to join the event: ".concat(window.location.href);
      var link = document.createElement('a');
      var content = ['BEGIN:VCALENDAR\n', 'VERSION:2.0\n', 'BEGIN:VEVENT\n', "DTSTART:".concat(_EventDateFormatter.default.formatDateForGoogleCalenderLink(startAt), "\n"), "DTEND:".concat(_EventDateFormatter.default.formatDateForGoogleCalenderLink(endAt), "\n"), "SUMMARY:".concat(title, "\n"), "DESCRIPTION:".concat(details, "\n"), "LOCATION:".concat(location, "\n"), 'END:VEVENT\n', 'END:VCALENDAR\n'];
      var file = new Blob(content, {
        type: 'text/plain'
      });
      link.href = URL.createObjectURL(file);
      link.download = 'event.ics';
      link.click();
      URL.revokeObjectURL(link.href);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          event = _this$props.event,
          group = _this$props.group,
          attachmentCdn = _this$props.attachmentCdn;
      var _this$state = this.state,
          isAttendee = _this$state.isAttendee,
          showModalEditRsvp = _this$state.showModalEditRsvp,
          rsvpStatus = _this$state.rsvpStatus,
          isAttendeesLoading = _this$state.isAttendeesLoading,
          page = _this$state.page,
          attendees = _this$state.attendees,
          attendeeCount = _this$state.attendeeCount,
          showModalAttendConfirmation = _this$state.showModalAttendConfirmation,
          isLoadingAttend = _this$state.isLoadingAttend,
          isLoadingConfirm = _this$state.isLoadingConfirm,
          isLoadingUpdate = _this$state.isLoadingUpdate;
      var id = event.id,
          title = event.title,
          type = event.type,
          startAt = event.startAt,
          endAt = event.endAt,
          image = event.image,
          location = event.location,
          link = event.link,
          linkLabel = event.linkLabel,
          content = event.content,
          isOpenForSignUp = event.isOpenForSignUp,
          isLoggedInUserAttendee = event.isLoggedInUserAttendee,
          confirmationMessage = event.confirmationMessage,
          externalRegistrationUrl = event.externalRegistrationUrl,
          externalRegistrationUrlLabel = event.externalRegistrationUrlLabel;

      var isPastEvent = _EventDateFormatter.default.isPastEvent(endAt);

      return (0, _preact.h)("div", null, (0, _preact.h)(_EventHeader.default, {
        eventId: id,
        title: title,
        scheduleAt: this.scheduleAt,
        startAt: startAt,
        endAt: endAt,
        isOpenForSignUp: isOpenForSignUp,
        isLoggedInUserAttendee: isLoggedInUserAttendee,
        image: image,
        type: type,
        confirmationMessage: confirmationMessage,
        isEventEngagementEnabled: this.isEventEngagementEnabled,
        isPastEvent: isPastEvent,
        isAttendee: isAttendee,
        isLoadingAttend: isLoadingAttend,
        showModalEditRsvp: showModalEditRsvp,
        showModalAttendConfirmation: showModalAttendConfirmation,
        onCloseModalAttendConfirmation: this.onCloseModalAttendConfirmation,
        rsvpStatus: rsvpStatus,
        onAttend: this.onAttend,
        onEditRsvp: this.onEditRsvp,
        onCloseModalEditRsvp: this.onCloseModalEditRsvp,
        onAttendanceChanged: function onAttendanceChanged(value) {
          return _this2.onAttendanceChanged(value);
        },
        onUpdateRsvp: /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
            return _regenerator.default.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.next = 2;
                    return _this2.onUpdateRsvp(e);

                  case 2:
                    return _context4.abrupt("return", _context4.sent);

                  case 3:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }(),
        isLoadingConfirm: isLoadingConfirm,
        isLoadingUpdate: isLoadingUpdate,
        eventContent: content,
        externalRegistrationUrl: externalRegistrationUrl,
        externalRegistrationUrlLabel: externalRegistrationUrlLabel,
        googleCalendarLink: this.createGoogleCalendarLink(),
        outlookCalendarLink: this.createOutlookCalendarLink(),
        office365CalendarLink: this.createOffice365CalendarLink(),
        appleCalendarICSDownloader: this.appleCalendarICSDownloader
      }), (0, _preact.h)("div", {
        className: "event-body-container"
      }, (0, _preact.h)("div", {
        className: "event-content-wrapper"
      }, (0, _preact.h)("div", {
        className: "event-content-container"
      }, (0, _preact.h)("div", {
        className: "event-content__header_label"
      }, (0, _preact.h)(_phrase.default, {
        p: "events.about",
        m: "Forum"
      })), (0, _preact.h)(_Content.default, {
        content: content,
        className: "event__content"
      })), !externalRegistrationUrl && (0, _preact.h)(_EventAttendees.default, {
        isPastEvent: isPastEvent,
        eventId: id,
        attendees: attendees,
        attendeeCount: attendeeCount,
        page: page,
        isEventEngagementEnabled: this.isEventEngagementEnabled,
        isLoading: isAttendeesLoading,
        loadNextPage: this.loadNextPage
      }), (0, _preact.h)(_FeaturedTopicsListAsSearchResults.default, {
        eventId: id,
        attachmentCdn: attachmentCdn
      })), (0, _preact.h)(_EventDetails.default, {
        scheduleAt: this.scheduleAt,
        location: location,
        link: link,
        linkLabel: linkLabel,
        group: group,
        attachmentCdn: attachmentCdn,
        googleCalendarLink: this.createGoogleCalendarLink(),
        outlookCalendarLink: this.createOutlookCalendarLink(),
        office365CalendarLink: this.createOffice365CalendarLink(),
        appleCalendarICSDownloader: this.appleCalendarICSDownloader,
        isPastEvent: isPastEvent
      })));
    }
  }]);
  return EventView;
}(_preact.Component);

var _default = EventView;
exports.default = _default;